import { z } from 'zod/v4';

const hrefSchema = z
  .object({
    href: z.string().url(),
  })
  .optional();

const pagedCollectionSchema = z.object({
  offset: z.number().min(0),
  limit: z.number().min(1),
  size: z.number().min(0),
  unfilteredSize: z.preprocess(
    (value) => (value === null || typeof value === 'undefined' ? -1 : value),
    z.number()
  ),
  first: hrefSchema,
  previous: hrefSchema,
  next: hrefSchema,
  last: hrefSchema,
});

/**
 * Use this to create a PagedCollectionSchema for a given Zod schema for endpoints that return paged collection responses.
 *
 * Note that if a response returns an unfilteredSize that's either null or undefined, the value will be transformed to -1
 * @param schema Zod schema to create the data array
 * @returns A PagedCollectionSchema with a data attribute that's a Zod Array of the passed in Zod schema
 */
export function createPagedCollectionSchema<T extends z.ZodTypeAny>(schema: T) {
  return pagedCollectionSchema.extend({
    data: z.array(schema),
  });
}
